import * as React from "react";
import { useContext, useEffect, useState } from "react";
import "./App.css";
import {
    CommandBar,
    Fabric,
    FontSizes,
    getTheme,
    initializeIcons,
    Nav,
    NeutralColors,
    Stack,
    Toggle,
} from "@fluentui/react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "./App.css";
import AuthContext from "./Services/AuthContext";

const theme = getTheme();
initializeIcons();

const navStylesRoot = {width: 220, height: 'calc(100vh - 44px)', display: 'flex', flexDirection: 'column'};
const navStyles = {root: {width: 220, height: 'calc(100vh - 104px)', borderBottom: '1px solid rgb(237, 235, 233)'}};
const netGrossToggleStyle = {root: {display: 'flex', alignItems: 'center', height: '60px', justifyContent: 'space-around'}};
const barStyles = {boxShadow: theme.effects.elevation8};
const navLogo = (<Link to='/' style={{
    fontSize: FontSizes.size20,
    textDecoration: 'none',
    color: NeutralColors.gray210,
    verticalAlign: 'middle',
    outline: 'none'
}}><img src={process.env.PUBLIC_URL + '/favicon/android-icon-36x36.png'} alt="Logo"/>
    <div style={{float: 'right', margin: '10px'}}>Xonite One</div>
</Link>);
const navLinkGroups = [
    {
        name: 'CRM',
        expandAriaLabel: 'Rozwiń',
        collapseAriaLabel: 'Zwiń',
        links: [
            {
                key: 'Ventures',
                name: 'Kontrakty',
                url: '/',
            },
            {
                key: 'Prospecting',
                name: 'Prospecting',
                url: '/prospecting',
            },
            {
                key: 'Persons',
                name: 'Osoby',
                url: '/person',
            },
            {
                key: 'Finalization',
                name: 'Odbiory',
                url: '/finalization',
            },
            {
                key: 'Task',
                name: 'Zadania',
                url: '/task',
            },
            {
                key: 'ChecklistItem',
                name: 'Lista Kontrolna',
                url: '/checklist',
            },
            {
                key: 'Contractor',
                name: 'Wykonawcy',
                url: '/contractor',
            },
            {
                key: 'Report',
                name: 'Raporty',
                url: '/report',
            },

        ],
    },
    {
        name: 'Finanse',
        expandAriaLabel: 'Rozwiń',
        collapseAriaLabel: 'Zwiń',
        collapseByDefault: true,
        links: [
            {
                key: 'Costs',
                name: 'Koszty',
                url: '/cost',
            },
            {
                key: 'InvoiceTodo',
                name: 'Fakturowanie',
                url: '/invoice/todo',
            },
            {
                key: 'IngImport',
                name: 'Import ING',
                url: '/import/ing',
            },
            {
                key: 'SantanderImport',
                name: 'Import Santander',
                url: '/import/santander',
            },
            {
                key: 'mBankImport',
                name: 'Import mBank',
                url: '/import/mbank',
            },
            {
                key: 'Payment',
                name: 'Płatności ',
                url: '/payment',
            },
            {
                key: 'PaymentRetention',
                name: 'Płatności zatrzymane',
                url: '/payment/retention',
            },
            {
                key: 'PaymentArchive',
                name: 'Płatności archiwalne',
                url: '/payment/archive',
            }
        ],
    },
    {
        name: 'Ustawienia',
        expandAriaLabel: 'Rozwiń',
        collapseAriaLabel: 'Zwiń',
        collapseByDefault: true,
        links: [
            {
                key: 'DocumentType',
                name: 'Dokumenty',
                url: '/document',
            },
            {
                key: 'AgreementCategory',
                name: 'Kategorie Umowy',
                url: '/agreement_category',
            },            {
                key: 'Counter',
                name: 'Liczniki',
                url: '/counter',
            },
            {
                key: 'Notification',
                name: 'Powiadomienia',
                url: '/notification',
            },
            {
                key: 'Users',
                name: 'Konta',
                url: '/user',
            }
        ],
    },

];


const _logo =
    {
        key: 'logo',
        text: navLogo,
        renderedInOverflow: false

        // This needs an ariaLabel since it's icon-only
    }
;

const FabricNav = () => {
    const navigate = useNavigate();

    const handleLinkClick = (event, element) => {
        event.preventDefault();
        navigate(element.url);
    };
    const _setToggle = (e, checked) => {
        localStorage.setItem('net_gross', checked);
        window.dispatchEvent(new Event('netGross'));
    }

    var optionalProps = {};
    if (localStorage.getItem('net_gross') === 'true') optionalProps.defaultChecked = true;

    return (
        <div style={navStylesRoot}>
        <Nav
            onLinkClick={handleLinkClick}
            ariaLabel="Xonite One Navigation Panel"
            styles={navStyles}
            groups={navLinkGroups}
        />
            <Toggle onText="Brutto" {...optionalProps} offText="Netto" styles={netGrossToggleStyle} onChange={_setToggle}/>
        </div>
    );
};

const stackItemStyles = {
    root: {
        alignItems: 'top',
        display: 'flex',
        height: 'calc(100vh - 52px)',
        width: 'calc(100vw - 220px)',
        justifyContent: 'center',
        overflow: 'auto',
        marginTop: 8
    },
};

const nonShrinkingStackItemStyles = {
    root: {
        alignItems: 'top',
        display: 'flex',
        height: 'calc(100vh - 44px)',
        justifyContent: 'center',
        overflow: 'hidden',
        width: 220,
        boxShadow: theme.effects.elevation4
    },
};

const stackStyles = {
    root: {
        overflow: 'hidden',
        width: '100vw',
        height: 'calc(100vh - 44px)'
    },
};

function App() {
    const [user, setUser] = useContext(AuthContext);
    const navigate = useNavigate();
    const [actions, setActions] = useState([]);

    useEffect(() => {
        if (user.token === "" || user.expiry < Date.now()) {
            navigate("/login");
        }
    },[user])

    return (
        <Fabric className="App">
            <CommandBar
                shiftOnReduce={true}
                items={[_logo, {
                    key: 'exp',
                    text: Math.round((user.expiry - Date.now())/60000) + 'm',
                    renderedInOverflow: false,
                    onClick: () => setUser({token: ""})
                    // This needs an ariaLabel since it's icon-only
                }]}
                farItems={actions}
                ariaLabel="Użyj prawo lewo na klawiaturze w celu nawigacji po akcjach"
                style={barStyles}
            />
            <Stack horizontal styles={stackStyles}>
                <Stack.Item styles={nonShrinkingStackItemStyles}>
                    <FabricNav/>
                </Stack.Item>
                <Stack.Item styles={stackItemStyles} data-is-scrollable="true">

                    <Outlet context={(state) => setActions(state)}/>

                </Stack.Item>
            </Stack>
        </Fabric>
    );
}

export default App;
